















import { defineComponent, reactive, toRefs } from "@vue/composition-api"

export default defineComponent({
  props: ["selectAccount"],

  setup() {
    const qqIcon = require("../../../../ui/assets/mobile/images/icon-qq.png")
    const wechatIcon = require("../../../../ui/assets/mobile/images/icon-wechat.png")

    const state = reactive({
      display: false
    })

    const show = () => {
      state.display = true
    }

    const close = () => {
      state.display = false
    }

    return {
      ...toRefs(state),
      qqIcon,
      wechatIcon,
      show,
      close
    }
  }
})
